import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants";

const API_CONTROLLER = "users";

export class UserApi {
    static getUser(){
        const url = `${ROOT_URL}/${API_CONTROLLER}/me`;
        return authAxios.get(url);
    }
    static updateMe(userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/me`;
        //console.log(userData);
        return authAxios.put(url, userData);
    }
    static getUserDetail(username){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${username}`;
        return authAxios.get(url);
    }
    static updateUserDetail(username, userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${username}`;
        return authAxios.put(url, userData);
    }
    static getUserDetailWard(username){
        const url = `${ROOT_URL}/${API_CONTROLLER}/ward/${username}`;
        return authAxios.get(url);
    }
    static updateUserDetailWard(username, userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/ward/${username}`;
        return authAxios.put(url, userData);
    }
    static resetUserCredentials(username, userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${username}/reset-credentials`;
        return authAxios.post(url, userData)
    }

    static resetWardUserCredentials(username, userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/${username}/reset-credentials-ward`;
        return authAxios.post(url, userData)
    }

    static updateUserCredentials(userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/update-credentials`;
        return authAxios.post(url, userData);
    }
    static createUser(userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/create`;
        return authAxios.post(url, userData);
    }
    static createWardUser(userData){
        const url = `${ROOT_URL}/${API_CONTROLLER}/create`;
        return authAxios.post(url, userData);
    }
    static getRoles() {
        const url = `${ROOT_URL}/${API_CONTROLLER}/front-end-settings`
        return authAxios.get(url);
    }
    static getUserList(userPaging){
        const url =`${ROOT_URL}/${API_CONTROLLER}/search`;
        return authAxios.post(url, userPaging);
    }
}
